module.exports = __webpack_public_path__ + "static/media/home_bg_cinza.d4831186.png";